'use client';

import {
  WizardAction,
  WizardState,
} from '@/app/(intakeFormV2)/intake-v2/types';
import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import { useWizardSessionLifecycle } from '../hooks/useWizardSessionLifecycle';
import { wizardReducer } from './wizardReducer';

export const intakeInitialWizardState: WizardState = {
  sessionId: null,
  currentStepIndex: 0,
  completedSteps: [],
  formData: {},
  leadId: null,
  contactId: null,
  accountId: null,
  opportunityId: null,
  isLoading: true,
  isSaving: false,
  error: null,
};

type TContextValue = {
  state: WizardState;
  dispatch: undefined | React.Dispatch<WizardAction>;
};

export const IntakeWizardContext = createContext<TContextValue>({
  state: intakeInitialWizardState,
  dispatch: undefined,
});

type WizardProviderProps = PropsWithChildren;

export const WizardProvider = ({ children }: WizardProviderProps) => {
  const [state, dispatch] = useReducer(wizardReducer, intakeInitialWizardState);

  useWizardSessionLifecycle(state, dispatch);

  const contextValue = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state]
  );

  return (
    <IntakeWizardContext.Provider value={contextValue}>
      {children}
    </IntakeWizardContext.Provider>
  );
};

export const useIntakeWizardContext = () => {
  const { state, dispatch } = useContext(IntakeWizardContext);

  if (!dispatch) {
    throw new Error('missing dispatch on "useIntakeWizardContext";');
  }

  return { state, dispatch };
};
